export default "__VITE_ASSET__0e9a52e1__"